import React from "react";
import PropTypes from "prop-types";
import { View, Text } from "@react-pdf/renderer";
import styles from "./navigation.styles";

export default function Navigation({ active }) {
  return (
    <View style={styles.navigation}>
      <View
        style={[styles.navigationItem, active === "first" && styles.activeNav]}
      >
        <Text
          style={[
            styles.navigationText,
            active === "first" && styles.activeNavText
          ]}
        >
          Audience
        </Text>
      </View>
      <View
        style={[styles.navigationItem, active === "second" && styles.activeNav]}
      >
        <Text
          style={[
            styles.navigationText,
            active === "second" && styles.activeNavText
          ]}
        >
          Map
        </Text>
      </View>
      <View
        style={[styles.navigationItem, active === "third" && styles.activeNav]}
      >
        <Text
          style={[
            styles.navigationText,
            active === "third" && styles.activeNavText
          ]}
        >
          Key Demographics
        </Text>
      </View>
    </View>
  );
}
Navigation.propTypes = {
  active: PropTypes.string
};

Navigation.defaultProps = {
  active: "first"
};
